import angular from 'angular';

RedemptionCountFilter.$inject = [];

/**
 * A coupon created before redemption limits existed has no redemption count: counting started with
 * the feature, and orders redeemed before it are not counted. The coupons API treats the absent
 * count as 0 when it validates limits, so show it the same way.
 */
export function redemptionCount(value?: number | null): number {
  if (value === null || value === undefined) {
    return 0;
  }

  return value;
}

function RedemptionCountFilter() {
  return redemptionCount;
}

export const RedemptionCountFilterModule = angular
  .module('acme.view.application.coupons.list.filter.redemptionCount', [])
  .filter('redemptionCount', RedemptionCountFilter).name;
